// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%23667085%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg width=%2725%27 height=%2724%27 viewBox=%270 0 25 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M16.0068 6L9.75684 12.25L16.0068 18.5%27 stroke=%27%23344054%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg width=%2725%27 height=%2724%27 viewBox=%270 0 25 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M9.50684 19L15.7568 12.75L9.50684 6.5%27 stroke=%27%23344054%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg width=%2725%27 height=%2724%27 viewBox=%270 0 25 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M16.0068 6L9.75684 12.25L16.0068 18.5%27 stroke=%27%2398A2B3%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg width=%2725%27 height=%2724%27 viewBox=%270 0 25 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M9.50684 19L15.7568 12.75L9.50684 6.5%27 stroke=%27%2398A2B3%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E4E7EC; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #98A2B3; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select{
  appearance: none;
  background-color: #fff;
  border-color: #667085;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder{
  color: #667085;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit{
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}

select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio']{
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #667085;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox']{
  border-radius: 0px;
}

[type='radio']{
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active) {

  [type='checkbox']:checked{
    appearance: auto;
  }
}

[type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active) {

  [type='radio']:checked{
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active) {

  [type='checkbox']:indeterminate{
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='file']{
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

body{
  position: relative;
  z-index: 1;
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  font-family: Outfit, sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
}
.container{
  width: 100%;
}
@media (min-width: 375px){

  .container{
    max-width: 375px;
  }
}
@media (min-width: 425px){

  .container{
    max-width: 425px;
  }
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
@media (min-width: 2000px){

  .container{
    max-width: 2000px;
  }
}
.menu-item{
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}
.sub-pack ul li.menu-item{
  align-items: center;
}
.menu-item-active{
  --tw-bg-opacity: 1;
  background-color: rgb(236 243 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(70 95 255 / var(--tw-text-opacity, 1));
}
.menu-item-active:is(.dark *){
  background-color: rgb(70 95 255 / 0.12);
  --tw-text-opacity: 1;
  color: rgb(117 146 255 / var(--tw-text-opacity, 1));
}
.menu-item-inactive{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.menu-item-inactive:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}
.group:hover .menu-item-inactive{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.menu-item-inactive:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(208 213 221 / var(--tw-text-opacity, 1));
}
.menu-item-inactive:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
  --tw-text-opacity: 1;
  color: rgb(208 213 221 / var(--tw-text-opacity, 1));
}
.menu-item-icon-active{
  --tw-text-opacity: 1;
  color: rgb(70 95 255 / var(--tw-text-opacity, 1));
}
.menu-item-icon-active:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(117 146 255 / var(--tw-text-opacity, 1));
}
.menu-item-icon-inactive{
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.group:hover .menu-item-icon-inactive{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.menu-item-icon-inactive:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.group:hover .menu-item-icon-inactive:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(208 213 221 / var(--tw-text-opacity, 1));
}
.menu-dropdown-item{
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}
.sub-pack ul li.menu-dropdown-item{
  align-items: center;
}
.menu-dropdown-item-active{
  --tw-bg-opacity: 1;
  background-color: rgb(236 243 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(70 95 255 / var(--tw-text-opacity, 1));
}
.menu-dropdown-item-active:is(.dark *){
  background-color: rgb(70 95 255 / 0.12);
  --tw-text-opacity: 1;
  color: rgb(117 146 255 / var(--tw-text-opacity, 1));
}
.menu-dropdown-item-inactive{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.menu-dropdown-item-inactive:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}
.menu-dropdown-item-inactive:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(208 213 221 / var(--tw-text-opacity, 1));
}
.menu-dropdown-item-inactive:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}
.menu-dropdown-badge{
  display: block;
  border-radius: 9999px;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(70 95 255 / var(--tw-text-opacity, 1));
}
.menu-dropdown-badge:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(117 146 255 / var(--tw-text-opacity, 1));
}
.menu-dropdown-badge-active{
  --tw-bg-opacity: 1;
  background-color: rgb(221 233 255 / var(--tw-bg-opacity, 1));
}
.menu-dropdown-badge-active:is(.dark *){
  background-color: rgb(70 95 255 / 0.2);
}
.menu-dropdown-badge-inactive{
  --tw-bg-opacity: 1;
  background-color: rgb(236 243 255 / var(--tw-bg-opacity, 1));
}
.group:hover .menu-dropdown-badge-inactive{
  --tw-bg-opacity: 1;
  background-color: rgb(221 233 255 / var(--tw-bg-opacity, 1));
}
.menu-dropdown-badge-inactive:is(.dark *){
  background-color: rgb(70 95 255 / 0.15);
}
.group:hover .menu-dropdown-badge-inactive:is(.dark *){
  background-color: rgb(70 95 255 / 0.2);
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-right-\\[240px\\]{
  right: -240px;
}
.-top-3{
  top: -0.75rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-6{
  bottom: 1.5rem;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1\\/2{
  left: 50%;
}
.left-4{
  left: 1rem;
}
.right-0{
  right: 0px;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1\\/2{
  top: 50%;
}
.top-3{
  top: 0.75rem;
}
.top-\\[22px\\]{
  top: 22px;
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.-z-1{
  z-index: -1;
}
.-z-10{
  z-index: -10;
}
.z-1{
  z-index: 1;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-999{
  z-index: 999;
}
.z-9999{
  z-index: 9999;
}
.z-99999{
  z-index: 99999;
}
.order-2{
  order: 2;
}
.order-3{
  order: 3;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-start-1{
  grid-column-start: 1;
}
.row-start-1{
  grid-row-start: 1;
}
.float-end{
  float: inline-end;
}
.\\!m-0{
  margin: 0px !important;
}
.m-4{
  margin: 1rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.-my-6{
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-ml-5{
  margin-left: -1.25rem;
}
.-mt-0\\.5{
  margin-top: -0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[22px\\]{
  margin-bottom: 22px;
}
.ml-0{
  margin-left: 0px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-9{
  margin-left: 2.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[17px\\]{
  margin-top: 17px;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[21\\/9\\]{
  aspect-ratio: 21/9;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.size-12{
  width: 3rem;
  height: 3rem;
}
.size-5{
  width: 1.25rem;
  height: 1.25rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9\\.5{
  height: 2.375rem;
}
.h-\\[212px\\]{
  height: 212px;
}
.h-\\[450px\\]{
  height: 450px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[68px\\]{
  height: 68px;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-\\[330px\\]{
  max-height: 330px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9\\.5{
  width: 2.375rem;
}
.w-\\[23\\%\\]{
  width: 23%;
}
.w-\\[252px\\]{
  width: 252px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[290px\\]{
  width: 290px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[46px\\]{
  width: 46px;
}
.w-\\[68px\\]{
  width: 68px;
}
.w-\\[72\\.1875rem\\]{
  width: 72.1875rem;
}
.w-\\[79\\%\\]{
  width: 79%;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[1000px\\]{
  min-width: 1000px;
}
.min-w-\\[1102px\\]{
  min-width: 1102px;
}
.min-w-\\[650px\\]{
  min-width: 650px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-1\\.5{
  max-width: 0.375rem;
}
.max-w-10{
  max-width: 2.5rem;
}
.max-w-12{
  max-width: 3rem;
}
.max-w-14{
  max-width: 3.5rem;
}
.max-w-16{
  max-width: 4rem;
}
.max-w-2{
  max-width: 0.5rem;
}
.max-w-2\\.5{
  max-width: 0.625rem;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3{
  max-width: 0.75rem;
}
.max-w-3\\.5{
  max-width: 0.875rem;
}
.max-w-4{
  max-width: 1rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-6{
  max-width: 1.5rem;
}
.max-w-60{
  max-width: 15rem;
}
.max-w-8{
  max-width: 2rem;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[242px\\]{
  max-width: 242px;
}
.max-w-\\[250px\\]{
  max-width: 250px;
}
.max-w-\\[290px\\]{
  max-width: 290px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[630px\\]{
  max-width: 630px;
}
.max-w-\\[700px\\]{
  max-width: 700px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-screen-2xl{
  max-width: 1536px;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-initial{
  flex: 0 1 auto;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[95\\%\\]{
  --tw-translate-y: -95%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-5{
  row-gap: 1.25rem;
}
.gap-y-6{
  row-gap: 1.5rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-px > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-9 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.25rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(242 244 247 / var(--tw-divide-opacity, 1));
}
.self-center{
  align-self: center;
}
.justify-self-end{
  justify-self: end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-balance{
  text-wrap: balance;
}
.text-pretty{
  text-wrap: pretty;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-l-lg{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-\\[0\\.7px\\]{
  border-width: 0.7px;
}
.border-\\[1\\.25px\\]{
  border-width: 1.25px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-blue-light-500{
  --tw-border-opacity: 1;
  border-color: rgb(11 165 236 / var(--tw-border-opacity, 1));
}
.border-brand-500{
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
}
.border-error-500{
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(242 244 247 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-success-400{
  --tw-border-opacity: 1;
  border-color: rgb(50 213 131 / var(--tw-border-opacity, 1));
}
.border-success-500{
  --tw-border-opacity: 1;
  border-color: rgb(18 183 106 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-warning-500{
  --tw-border-opacity: 1;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-500{
  --tw-bg-opacity: 1;
  background-color: rgb(11 165 236 / var(--tw-bg-opacity, 1));
}
.bg-brand-100{
  --tw-bg-opacity: 1;
  background-color: rgb(221 233 255 / var(--tw-bg-opacity, 1));
}
.bg-brand-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 243 255 / var(--tw-bg-opacity, 1));
}
.bg-brand-500{
  --tw-bg-opacity: 1;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1));
}
.bg-brand-950{
  --tw-bg-opacity: 1;
  background-color: rgb(22 25 80 / var(--tw-bg-opacity, 1));
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-error-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}
.bg-error-400{
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}
.bg-error-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.bg-error-500{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(208 213 221 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(152 162 179 / var(--tw-bg-opacity, 1));
}
.bg-gray-400\\/50{
  background-color: rgb(152 162 179 / 0.5);
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(102 112 133 / var(--tw-bg-opacity, 1));
}
.bg-gray-500\\/75{
  background-color: rgb(102 112 133 / 0.75);
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(52 64 84 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(29 41 57 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 234 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(253 133 58 / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-success-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.bg-success-500{
  --tw-bg-opacity: 1;
  background-color: rgb(18 183 106 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-warning-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}
.bg-warning-500{
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-none{
  background-image: none;
}
.from-\\[\\#ff80b5\\]{
  --tw-gradient-from: #ff80b5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 128 181 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#9089fc\\]{
  --tw-gradient-to: #9089fc var(--tw-gradient-to-position);
}
.fill-current{
  fill: currentColor;
}
.fill-gray-500{
  fill: #667085;
}
.fill-white{
  fill: #FFFFFF;
}
.stroke-current{
  stroke: currentColor;
}
.stroke-gray-500{
  stroke: #667085;
}
.object-cover{
  object-fit: cover;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-36{
  padding-left: 9rem;
  padding-right: 9rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-4\\.5{
  padding-left: 1.125rem;
  padding-right: 1.125rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-\\[7px\\]{
  padding-left: 7px;
  padding-right: 7px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[4\\.5px\\]{
  padding-top: 4.5px;
  padding-bottom: 4.5px;
}
.pb-11{
  padding-bottom: 2.75rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-3\\.5{
  padding-left: 0.875rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-\\[62px\\]{
  padding-left: 62px;
}
.pl-\\[84px\\]{
  padding-left: 84px;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-11{
  padding-right: 2.75rem;
}
.pr-14{
  padding-right: 3.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pr-\\[84px\\]{
  padding-right: 84px;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-base\\/7{
  font-size: 1rem;
  line-height: 1.75rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/6{
  font-size: 0.875rem;
  line-height: 1.5rem;
}
.text-theme-sm{
  font-size: 14px;
  line-height: 20px;
}
.text-theme-xl{
  font-size: 20px;
  line-height: 30px;
}
.text-theme-xs{
  font-size: 12px;
  line-height: 18px;
}
.text-title-md{
  font-size: 36px;
  line-height: 44px;
}
.text-title-sm{
  font-size: 30px;
  line-height: 38px;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-\\[20px\\]{
  line-height: 20px;
}
.leading-normal{
  line-height: 1.5;
}
.leading-tight{
  line-height: 1.25;
}
.-tracking-\\[0\\.2px\\]{
  letter-spacing: -0.2px;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.text-blue-light-500{
  --tw-text-opacity: 1;
  color: rgb(11 165 236 / var(--tw-text-opacity, 1));
}
.text-brand-500{
  --tw-text-opacity: 1;
  color: rgb(70 95 255 / var(--tw-text-opacity, 1));
}
.text-brand-600{
  --tw-text-opacity: 1;
  color: rgb(54 65 245 / var(--tw-text-opacity, 1));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-error-500{
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}
.text-error-600{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}
.text-error-800{
  --tw-text-opacity: 1;
  color: rgb(145 32 24 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(208 213 221 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(71 84 103 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(236 74 10 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-success-500{
  --tw-text-opacity: 1;
  color: rgb(18 183 106 / var(--tw-text-opacity, 1));
}
.text-success-600{
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity, 1));
}
.text-warning-500{
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}
.text-warning-600{
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-75{
  opacity: 0.75;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-theme-lg{
  --tw-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  --tw-shadow-colored: 0px 12px 16px -4px var(--tw-shadow-color), 0px 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-theme-md{
  --tw-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  --tw-shadow-colored: 0px 4px 8px -2px var(--tw-shadow-color), 0px 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-theme-sm{
  --tw-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
  --tw-shadow-colored: 0px 1px 3px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-theme-xs{
  --tw-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-1{
  outline-width: 1px;
}
.-outline-offset-1{
  outline-offset: -1px;
}
.outline-gray-300{
  outline-color: #D0D5DD;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-black\\/5{
  --tw-ring-color: rgb(16 24 40 / 0.05);
}
.ring-gray-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(208 213 221 / var(--tw-ring-opacity, 1));
}
.ring-gray-900\\/10{
  --tw-ring-color: rgb(16 24 40 / 0.1);
}
.ring-indigo-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-red-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[32px\\]{
  --tw-backdrop-blur: blur(32px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
/* Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
    display: none;
  }
.no-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
.custom-scrollbar::-webkit-scrollbar{
  width: 0.375rem;
  height: 0.375rem;
}
.custom-scrollbar::-webkit-scrollbar-track{
  border-radius: 9999px;
}
.custom-scrollbar::-webkit-scrollbar-thumb{
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1));
}
.custom-scrollbar:is(.dark *)::-webkit-scrollbar-thumb{
  --tw-bg-opacity: 1;
  background-color: rgb(52 64 84 / var(--tw-bg-opacity, 1));
}
/* For Remove Date Icon */
input[type="date"]::-webkit-inner-spin-button,
  input[type="time"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-calendar-picker-indicator,
  input[type="time"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

/* @layer components {
  .menu-item {
    @apply relative flex items-center gap-3 px-3 py-2 font-medium rounded-lg text-theme-sm;
  }
  .menu-item-active {
    @apply bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400;
  }
  .menu-item-inactive {
    @apply text-gray-700 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-gray-300;
  }

  .menu-item-icon-active {
    @apply text-brand-500 dark:text-brand-400;
  }
  .menu-item-icon-inactive {
    @apply text-gray-500 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300;
  }

  .menu-item-arrow {
    @apply absolute right-2.5 top-1/2 -translate-y-1/2;
  }
  .menu-item-arrow-active {
    @apply rotate-180 stroke-brand-500 dark:stroke-brand-400;
  }
  .menu-item-arrow-inactive {
    @apply stroke-gray-500 group-hover:stroke-gray-700 dark:stroke-gray-400 dark:group-hover:stroke-gray-300;
  }

  .menu-dropdown-item {
    @apply relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-theme-sm font-medium;
  }
  .menu-dropdown-item-active {
    @apply bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400;
  }
  .menu-dropdown-item-inactive {
    @apply text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5;
  }

  .menu-dropdown-badge {
    @apply block rounded-full px-2.5 py-0.5 text-xs font-medium uppercase text-brand-500 dark:text-brand-400;
  }
  .menu-dropdown-badge-active {
    @apply bg-brand-100 dark:bg-brand-500/20;
  }
  .menu-dropdown-badge-inactive {
    @apply bg-brand-50 group-hover:bg-brand-100 dark:bg-brand-500/15 dark:group-hover:bg-brand-500/20;
  }
} */

.tableCheckbox:checked ~ span span{
  opacity: 1;
}
.tableCheckbox:checked ~ span{
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1));
}

/* third-party libraries CSS */
.apexcharts-legend-text{
  --tw-text-opacity: 1 !important;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
}
.apexcharts-legend-text:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
}

.apexcharts-text{
  fill: #344054 !important;
}

.apexcharts-text:is(.dark *){
  fill: #98A2B3 !important;
}

.apexcharts-tooltip.apexcharts-theme-light{
  gap: 0.25rem;
  border-radius: 0.5rem !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
  padding: 0.75rem;
  --tw-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06) !important;
  --tw-shadow-colored: 0px 1px 3px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.apexcharts-tooltip.apexcharts-theme-light:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1)) !important;
}

.apexcharts-tooltip-marker{
  margin-right: 0.375rem !important;
  height: 0.375rem !important;
  width: 0.375rem !important;
}
.apexcharts-legend-text{
  padding-left: 1.25rem !important;
  --tw-text-opacity: 1 !important;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
}
.apexcharts-legend-text:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
}
.apexcharts-tooltip-series-group{
  padding: 0px !important;
}
.apexcharts-tooltip-y-group{
  padding: 0px !important;
}
.apexcharts-tooltip-title{
  margin-bottom: 0px !important;
  border-bottom-width: 0px !important;
  background-color: transparent !important;
  padding: 0px !important;
  font-size: 10px !important;
  line-height: 1rem !important;
  --tw-text-opacity: 1 !important;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1)) !important;
}
.apexcharts-tooltip-title:is(.dark *){
  color: rgb(255 255 255 / 0.9) !important;
}
.apexcharts-tooltip-text{
  font-size: 12px !important;
  line-height: 18px !important;
  --tw-text-opacity: 1 !important;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
}
.apexcharts-tooltip-text:is(.dark *){
  color: rgb(255 255 255 / 0.9) !important;
}
.apexcharts-tooltip-text-y-value{
  font-weight: 500 !important;
}

.apexcharts-gridline{
  stroke: #F2F4F7 !important;
}

.apexcharts-gridline:is(.dark *){
  stroke: #1D2939 !important;
}
#chartTwo .apexcharts-datalabels-group{
  --tw-translate-y: -6rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
#chartTwo .apexcharts-datalabels-group .apexcharts-text{
  fill: #1D2939 !important;
  font-weight: 600 !important;
}
#chartTwo .apexcharts-datalabels-group .apexcharts-text:is(.dark *){
  fill: rgb(255 255 255 / 0.9) !important;
}

#chartSixteen .apexcharts-legend{
  padding: 0px !important;
  padding-left: 1.5rem !important;
}

.jvectormap-container{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}

.jvectormap-container:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1)) !important;
}
.jvectormap-region.jvectormap-element{
  fill: #D0D5DD !important;
}
.jvectormap-region.jvectormap-element:hover{
  fill: #465FFF !important;
}
.jvectormap-region.jvectormap-element:is(.dark *){
  fill: #344054 !important;
}
.jvectormap-region.jvectormap-element:hover:is(.dark *){
  fill: #465FFF !important;
}
.jvectormap-marker.jvectormap-element{
  stroke: #E4E7EC !important;
}
.jvectormap-marker.jvectormap-element:is(.dark *){
  stroke: #1D2939 !important;
}
.jvectormap-tip{
  border-style: none !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1)) !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.jvectormap-zoomin,
.jvectormap-zoomout{
  display: none !important;
}

.stocks-slider-outer .swiper-button-next:after,
.stocks-slider-outer .swiper-button-prev:after{
  display: none;
}

.stocks-slider-outer .swiper-button-next,
.stocks-slider-outer .swiper-button-prev{
  position: static !important;
  margin-top: 0px;
  height: 2rem;
  width: 2.25rem;
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1 !important;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.stocks-slider-outer .swiper-button-next:hover,
.stocks-slider-outer .swiper-button-prev:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}

.stocks-slider-outer .swiper-button-next:is(.dark *),
.stocks-slider-outer .swiper-button-prev:is(.dark *){
  border-color: rgb(255 255 255 / 0.03);
  --tw-bg-opacity: 1;
  background-color: rgb(29 41 57 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1 !important;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
}

.stocks-slider-outer .swiper-button-next:hover:is(.dark *),
.stocks-slider-outer .swiper-button-prev:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
  color: rgb(255 255 255 / 0.9) !important;
}

.stocks-slider-outer .swiper-button-next.swiper-button-disabled,
.stocks-slider-outer .swiper-button-prev.swiper-button-disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  opacity: 0.5;
}

.stocks-slider-outer .swiper-button-next.swiper-button-disabled:is(.dark *),
.stocks-slider-outer .swiper-button-prev.swiper-button-disabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}

.stocks-slider-outer .swiper-button-next svg,
.stocks-slider-outer .swiper-button-prev svg{
  height: auto !important;
  width: auto !important;
}

.flatpickr-wrapper{
  width: 100%;
}
.flatpickr-calendar{
  margin-top: 0.5rem;
  border-radius: 0.75rem !important;
  border-width: 1px !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  padding: 1.25rem !important;
  --tw-text-opacity: 1 !important;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1)) !important;
}
.flatpickr-calendar:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(26 34 49 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
  --tw-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03) !important;
  --tw-shadow-colored: 0px 20px 24px -4px var(--tw-shadow-color), 0px 8px 8px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
@media (min-width: 375px){

  .flatpickr-calendar{
    width: auto !important;
  }
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg{
  stroke: #465FFF;
}
.flatpickr-calendar.arrowTop:before,
.flatpickr-calendar.arrowTop:after{
  display: none;
}

.flatpickr-current-month{
  padding: 0px !important;
}
.flatpickr-current-month .cur-month,
.flatpickr-current-month input.cur-year{
  height: auto !important;
  padding-top: 0px !important;
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
  font-weight: 500 !important;
  --tw-text-opacity: 1 !important;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1)) !important;
}
.flatpickr-current-month .cur-month:is(.dark *),
.flatpickr-current-month input.cur-year:is(.dark *){
  color: rgb(255 255 255 / 0.9) !important;
}

.flatpickr-prev-month,
.flatpickr-next-month{
  padding: 0px !important;
}

.flatpickr-weekdays{
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  height: auto;
  background-color: transparent !important;
}

.flatpickr-weekday{
  background-color: transparent !important;
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 500 !important;
  --tw-text-opacity: 1 !important;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1)) !important;
}

.flatpickr-weekday:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
}

.flatpickr-day{
  display: flex !important;
  align-items: center !important;
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 500 !important;
  --tw-text-opacity: 1 !important;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1)) !important;
}

.flatpickr-day:is(.dark *){
  color: rgb(255 255 255 / 0.9) !important;
}

.flatpickr-day:hover:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(208 213 221 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1)) !important;
}
.flatpickr-day.nextMonthDay,
.flatpickr-day.prevMonthDay{
  --tw-text-opacity: 1 !important;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1)) !important;
}

.flatpickr-months > .flatpickr-month {
  background: none !important;
}
.flatpickr-month .flatpickr-current-month .flatpickr-monthDropdown-months {
  background: none !important;
  appearance: none;
  background-image: none !important;
  font-weight: 500;
}
.flatpickr-month
  .flatpickr-current-month
  .flatpickr-monthDropdown-months:focus {
  outline: none !important;
  border: 0 !important;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month{
  top: 1.75rem !important;
  background-color: transparent !important;
}
.flatpickr-months .flatpickr-prev-month:is(.dark *),
.flatpickr-months .flatpickr-next-month:is(.dark *){
  fill: #FFFFFF !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month{
  left: 1.75rem !important;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month{
  right: 1.75rem !important;
}
.flatpickr-days{
  border-width: 0px !important;
}
span.flatpickr-weekday,
.flatpickr-months .flatpickr-month{
  background-image: none !important;
}
span.flatpickr-weekday:is(.dark *),
.flatpickr-months .flatpickr-month:is(.dark *){
  fill: #FFFFFF !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.flatpickr-innerContainer{
  border-bottom-width: 0px !important;
}
.flatpickr-months .flatpickr-month{
  background-image: none !important;
}
.flatpickr-day.inRange {
  box-shadow: -5px 0 0 #f9fafb, 5px 0 0 #f9fafb !important;
}
.flatpickr-day.inRange:is(.dark *){
  --tw-shadow: -5px 0 0 #262d3c, 5px 0 0 #262d3c !important;
  --tw-shadow-colored: -5px 0 0 var(--tw-shadow-color), 5px 0 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 250 251 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.flatpickr-day.inRange:is(.dark *),
.flatpickr-day.prevMonthDay.inRange:is(.dark *),
.flatpickr-day.nextMonthDay.inRange:is(.dark *),
.flatpickr-day.today.inRange:is(.dark *),
.flatpickr-day.prevMonthDay.today.inRange:is(.dark *),
.flatpickr-day.nextMonthDay.today.inRange:is(.dark *),
.flatpickr-day:hover:is(.dark *),
.flatpickr-day.prevMonthDay:hover:is(.dark *),
.flatpickr-day.nextMonthDay:hover:is(.dark *),
.flatpickr-day:focus:is(.dark *),
.flatpickr-day.prevMonthDay:focus:is(.dark *),
.flatpickr-day.nextMonthDay:focus:is(.dark *){
  border-width: 0px !important;
  border-color: rgb(255 255 255 / 0.05) !important;
  background-color: rgb(255 255 255 / 0.05) !important;
}
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.selected,
.flatpickr-day.endRange{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.flatpickr-day.selected:is(.dark *),
.flatpickr-day.startRange:is(.dark *),
.flatpickr-day.selected:is(.dark *),
.flatpickr-day.endRange:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: #465fff;
  --tw-border-opacity: 1 !important;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1)) !important;
}
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.inRange:hover,
.flatpickr-day.startRange.inRange:hover,
.flatpickr-day.endRange.inRange:hover,
.flatpickr-day.selected:focus:hover,
.flatpickr-day.startRange:focus:hover,
.flatpickr-day.endRange:focus:hover,
.flatpickr-day.selected:hover:hover,
.flatpickr-day.startRange:hover:hover,
.flatpickr-day.endRange:hover:hover,
.flatpickr-day.selected.prevMonthDay:hover,
.flatpickr-day.startRange.prevMonthDay:hover,
.flatpickr-day.endRange.prevMonthDay:hover,
.flatpickr-day.selected.nextMonthDay:hover,
.flatpickr-day.startRange.nextMonthDay:hover,
.flatpickr-day.endRange.nextMonthDay:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1)) !important;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 #465fff;
}

.flatpickr-months .flatpickr-prev-month svg:hover,
.flatpickr-months .flatpickr-next-month svg:hover,
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover{
  fill: none !important;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: none !important;
}

.flatpickr-calendar.static{
  right: 0px;
}

.fc .fc-view-harness{
  max-width: 100%;
  overflow-x: auto;
}

.fc .fc-view-harness::-webkit-scrollbar{
  width: 0.375rem;
  height: 0.375rem;
}

.fc .fc-view-harness::-webkit-scrollbar-track{
  border-radius: 9999px;
}

.fc .fc-view-harness::-webkit-scrollbar-thumb{
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1));
}

.fc .fc-view-harness:is(.dark *)::-webkit-scrollbar-thumb{
  --tw-bg-opacity: 1;
  background-color: rgb(52 64 84 / var(--tw-bg-opacity, 1));
}
.fc-dayGridMonth-view.fc-view.fc-daygrid{
  min-width: 718px;
}
.fc .fc-scrollgrid-section > * {
  border-right-width: 0;
  border-bottom-width: 0;
}
.fc .fc-scrollgrid {
  border-left-width: 0;
}
.fc .fc-toolbar.fc-header-toolbar{
  flex-direction: column;
  gap: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
}
@media (min-width: 640px){

  .fc .fc-toolbar.fc-header-toolbar{
    flex-direction: row;
  }
}
.fc-button-group{
  gap: 0.5rem;
}
.fc-button-group .fc-button{
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem !important;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
  background-color: transparent;
}
.sub-pack ul li.fc-button-group .fc-button{
  align-items: center;
}
.fc-button-group .fc-button:hover{
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.fc-button-group .fc-button:focus{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.fc-button-group .fc-button:active{
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
  background-color: transparent !important;
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.fc-button-group .fc-button:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1));
}
.fc-button-group .fc-button:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}
.fc-button-group .fc-button:active:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1)) !important;
}

.fc-button-group .fc-button.fc-prev-button:before{
  margin-top: 0.25rem;
  display: inline-block;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.fc-button-group .fc-button.fc-next-button:before{
  margin-top: 0.25rem;
  display: inline-block;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.dark .fc-button-group .fc-button.fc-prev-button:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.dark .fc-button-group .fc-button.fc-next-button:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.fc-button-group .fc-button .fc-icon{
  display: none;
}
.fc-addEventButton-button{
  border-radius: 0.5rem !important;
  border-width: 0px !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1)) !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
  font-weight: 500 !important;
}
.fc-addEventButton-button:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(54 65 245 / var(--tw-bg-opacity, 1)) !important;
}
.fc-addEventButton-button:focus{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.fc-toolbar-title{
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
  font-weight: 500 !important;
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}
.fc-toolbar-title:is(.dark *){
  color: rgb(255 255 255 / 0.9);
}
.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child{
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
  padding: 0.125rem;
}
.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}
.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child .fc-button{
  height: auto !important;
  width: auto !important;
  border-radius: 0.375rem;
  border-width: 0px !important;
  background-color: transparent;
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child .fc-button:hover{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child .fc-button:focus{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child .fc-button:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.fc-header-toolbar.fc-toolbar
  .fc-toolbar-chunk:last-child
  .fc-button.fc-button-active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.fc-header-toolbar.fc-toolbar
  .fc-toolbar-chunk:last-child
  .fc-button.fc-button-active:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(29 41 57 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.fc-theme-standard th{
  border-left-width: 0px !important;
  border-right-width: 0px !important;
  border-top-width: 1px;
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  text-align: left !important;
}
.fc-theme-standard th:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}
.fc-theme-standard td,
.fc-theme-standard .fc-scrollgrid{
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1)) !important;
}
.fc-theme-standard td:is(.dark *),
.fc-theme-standard .fc-scrollgrid:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1)) !important;
}
.fc .fc-col-header-cell-cushion{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.fc .fc-daygrid-day.fc-day-today{
  background-color: transparent;
}
.fc .fc-daygrid-day{
  padding: 0.5rem;
}
.fc .fc-daygrid-day.fc-day-today .fc-scrollgrid-sync-inner{
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}
.fc .fc-daygrid-day.fc-day-today .fc-scrollgrid-sync-inner:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}
.fc .fc-daygrid-day-number{
  padding: 0.75rem !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.fc .fc-daygrid-day-number:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.fc .fc-daygrid-day-top{
  flex-direction: row !important;
}
.fc .fc-day-other .fc-daygrid-day-top {
  opacity: 1;
}
.fc .fc-day-other .fc-daygrid-day-top .fc-daygrid-day-number{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.fc .fc-day-other .fc-daygrid-day-top .fc-daygrid-day-number:is(.dark *){
  color: rgb(255 255 255 / 0.3);
}
.event-fc-color{
  border-radius: 0.5rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1rem;
  padding-right: 0.75rem;
}
.event-fc-color .fc-event-title{
  padding: 0px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.fc-daygrid-event-dot{
  margin-left: 0px;
  margin-right: 0.75rem;
  height: 1.25rem;
  width: 0.25rem;
  border-radius: 0.25rem;
  border-style: none;
}
.fc-event:focus{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.fc-daygrid-event.fc-event-start{
  margin-left: 0.75rem !important;
}
.event-fc-color.fc-bg-success{
  --tw-border-opacity: 1;
  border-color: rgb(236 253 243 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-danger{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 242 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-primary{
  --tw-border-opacity: 1;
  border-color: rgb(236 243 255 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(236 243 255 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-warning{
  --tw-border-opacity: 1;
  border-color: rgb(255 246 237 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 237 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-success .fc-daygrid-event-dot{
  --tw-bg-opacity: 1;
  background-color: rgb(18 183 106 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-danger .fc-daygrid-event-dot{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-primary .fc-daygrid-event-dot{
  --tw-bg-opacity: 1;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1));
}
.event-fc-color.fc-bg-warning .fc-daygrid-event-dot{
  --tw-bg-opacity: 1;
  background-color: rgb(251 101 20 / var(--tw-bg-opacity, 1));
}
.fc-direction-ltr .fc-timegrid-slot-label-frame{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.fc-direction-ltr .fc-timegrid-slot-label-frame:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.fc .fc-timegrid-axis-cushion{
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.fc .fc-timegrid-axis-cushion:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}

.input-date-icon::-webkit-inner-spin-button,
.input-date-icon::-webkit-calendar-picker-indicator {
  opacity: 0;
  -webkit-appearance: none;
}

.swiper-button-prev svg,
.swiper-button-next svg{
  height: auto !important;
  width: auto !important;
}

.carouselTwo .swiper-button-next:after,
.carouselTwo .swiper-button-prev:after,
.carouselFour .swiper-button-next:after,
.carouselFour .swiper-button-prev:after{
  display: none;
}
.carouselTwo .swiper-button-next.swiper-button-disabled,
.carouselTwo .swiper-button-prev.swiper-button-disabled,
.carouselFour .swiper-button-next.swiper-button-disabled,
.carouselFour .swiper-button-prev.swiper-button-disabled{
  background-color: rgb(255 255 255 / 0.6);
  opacity: 1 !important;
}
.carouselTwo .swiper-button-next,
.carouselTwo .swiper-button-prev,
.carouselFour .swiper-button-next,
.carouselFour .swiper-button-prev{
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 9999px;
  border-width: 0.5px;
  border-color: rgb(255 255 255 / 0.1);
  background-color: rgb(255 255 255 / 0.9);
  --tw-text-opacity: 1 !important;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1)) !important;
  --tw-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color), 0px 1px 3px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(10px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.carouselTwo .swiper-button-prev,
.carouselFour .swiper-button-prev{
  left: 0.75rem !important;
}

@media (min-width: 640px){

  .carouselTwo .swiper-button-prev,
.carouselFour .swiper-button-prev{
    left: 1rem !important;
  }
}

.carouselTwo .swiper-button-next,
.carouselFour .swiper-button-next{
  right: 0.75rem !important;
}

@media (min-width: 640px){

  .carouselTwo .swiper-button-next,
.carouselFour .swiper-button-next{
    right: 1rem !important;
  }
}

.carouselThree .swiper-pagination,
.carouselFour .swiper-pagination{
  bottom: 0.75rem !important;
  left: 50% !important;
  display: inline-flex;
  width: auto !important;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  gap: 0.375rem;
  border-radius: 40px;
  border-width: 0.5px;
  border-color: rgb(255 255 255 / 0.1);
  background-color: rgb(255 255 255 / 0.6);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  --tw-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color), 0px 1px 3px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(10px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

@media (min-width: 640px){

  .carouselThree .swiper-pagination,
.carouselFour .swiper-pagination{
    bottom: 1.25rem !important;
  }
}

.carouselThree .swiper-pagination-bullet,
.carouselFour .swiper-pagination-bullet{
  margin: 0px !important;
  height: 0.625rem;
  width: 0.625rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  opacity: 1;
  --tw-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.carouselThree .swiper-pagination-bullet-active,
.carouselFour .swiper-pagination-bullet-active{
  width: 1.625rem;
  border-radius: 0.75rem;
}

.form-check-input:checked ~ span{
  border-width: 6px;
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1));
}

.form-check-input:checked ~ span:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
}

.taskCheckbox:checked ~ .box span{
  --tw-bg-opacity: 1;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1));
  opacity: 1;
}
.taskCheckbox:checked ~ p{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
  text-decoration-line: line-through;
}
.taskCheckbox:checked ~ .box{
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(70 95 255 / var(--tw-bg-opacity, 1));
}
.taskCheckbox:checked ~ .box:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
}

.task {
  transition: all 0.2s ease; /* Smooth transition for visual effects */
  border-radius: 0.75rem;
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1),
    0px 1px 2px 0px rgba(16, 24, 40, 0.06);
  opacity: 0.8;
  cursor: grabbing; /* Changes the cursor to indicate dragging */
}

.custom-calendar .fc-h-event {
  background-color: transparent;
  border: none;
  color: black;
}
.fc.fc-media-screen{
  min-height: 100vh;
}
.animate-spin {
  animation: spin 1s linear infinite;
}

.sub-pack-parent{
  max-width: 80%;
}

.sub-pack{
  box-shadow: 0px 0px 20px -7px #000000;
}

.sub-pack ul li.flex{
  align-items: center;
}

.flexi-pack-amount{
  font-size: 2rem;
}

.file\\:mr-5::file-selector-button{
  margin-right: 1.25rem;
}

.file\\:border-collapse::file-selector-button{
  border-collapse: collapse;
}

.file\\:cursor-pointer::file-selector-button{
  cursor: pointer;
}

.file\\:rounded-l-lg::file-selector-button{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:border-r::file-selector-button{
  border-right-width: 1px;
}

.file\\:border-solid::file-selector-button{
  border-style: solid;
}

.file\\:border-gray-200::file-selector-button{
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
}

.file\\:bg-gray-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.file\\:py-3::file-selector-button{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.file\\:pl-3\\.5::file-selector-button{
  padding-left: 0.875rem;
}

.file\\:pr-3::file-selector-button{
  padding-right: 0.75rem;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:text-gray-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-800::placeholder{
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}

.hover\\:border-brand-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
}

.hover\\:bg-brand-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(54 65 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(228 231 236 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(152 162 179 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:text-brand-600:hover{
  --tw-text-opacity: 1;
  color: rgb(54 65 245 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}

.hover\\:ring-indigo-300:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}

.hover\\:file\\:bg-gray-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}

.focus\\:z-20:focus{
  z-index: 20;
}

.focus\\:border-0:focus{
  border-width: 0px;
}

.focus\\:border-brand-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(156 185 255 / var(--tw-border-opacity, 1));
}

.focus\\:border-error-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(253 162 155 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.focus\\:border-success-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(108 233 166 / var(--tw-border-opacity, 1));
}

.focus\\:shadow-focus-ring:focus{
  --tw-shadow: 0px 0px 0px 4px rgba(70, 95, 255, 0.12);
  --tw-shadow-colored: 0px 0px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-2:focus{
  outline-width: 2px;
}

.focus\\:-outline-offset-2:focus{
  outline-offset: -2px;
}

.focus\\:outline-offset-0:focus{
  outline-offset: 0px;
}

.focus\\:outline-indigo-600:focus{
  outline-color: #4f46e5;
}

.focus\\:ring:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-brand-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(70 95 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-brand-500\\/10:focus{
  --tw-ring-color: rgb(70 95 255 / 0.1);
}

.focus\\:ring-error-500\\/10:focus{
  --tw-ring-color: rgb(240 68 56 / 0.1);
}

.focus\\:ring-success-500\\/10:focus{
  --tw-ring-color: rgb(18 183 106 / 0.1);
}

.focus\\:ring-transparent:focus{
  --tw-ring-color: transparent;
}

.focus\\:ring-offset-0:focus{
  --tw-ring-offset-width: 0px;
}

.focus\\:file\\:ring-brand-300::file-selector-button:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 185 255 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:outline:focus-visible{
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible{
  outline-offset: 2px;
}

.focus-visible\\:outline-indigo-500:focus-visible{
  outline-color: #6366f1;
}

.focus-visible\\:outline-indigo-600:focus-visible{
  outline-color: #4f46e5;
}

.disabled\\:bg-brand-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 185 255 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:fill-gray-700{
  fill: #344054;
}

.group:hover .group-hover\\:text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}

.dark\\:block:is(.dark *){
  display: block;
}

.dark\\:hidden:is(.dark *){
  display: none;
}

.dark\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(29 41 57 / var(--tw-divide-opacity, 1));
}

.dark\\:divide-white\\/\\[0\\.05\\]:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.05);
}

.dark\\:border-blue-light-500\\/30:is(.dark *){
  border-color: rgb(11 165 236 / 0.3);
}

.dark\\:border-error-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}

.dark\\:border-error-500\\/30:is(.dark *){
  border-color: rgb(240 68 56 / 0.3);
}

.dark\\:border-gray-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(52 64 84 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(16 24 40 / var(--tw-border-opacity, 1));
}

.dark\\:border-success-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(18 183 106 / var(--tw-border-opacity, 1));
}

.dark\\:border-success-500\\/30:is(.dark *){
  border-color: rgb(18 183 106 / 0.3);
}

.dark\\:border-warning-500\\/30:is(.dark *){
  border-color: rgb(247 144 9 / 0.3);
}

.dark\\:border-white\\/\\[0\\.05\\]:is(.dark *){
  border-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-\\[\\#1e2636\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 38 54 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-light-500\\/15:is(.dark *){
  background-color: rgb(11 165 236 / 0.15);
}

.dark\\:bg-brand-500\\/15:is(.dark *){
  background-color: rgb(70 95 255 / 0.15);
}

.dark\\:bg-error-500\\/15:is(.dark *){
  background-color: rgb(240 68 56 / 0.15);
}

.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(52 64 84 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(29 41 57 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(16 24 40 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-dark:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(26 34 49 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-success-500\\/15:is(.dark *){
  background-color: rgb(18 183 106 / 0.15);
}

.dark\\:bg-transparent:is(.dark *){
  background-color: transparent;
}

.dark\\:bg-warning-500\\/15:is(.dark *){
  background-color: rgb(247 144 9 / 0.15);
}

.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-white\\/\\[0\\.03\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:fill-gray-400:is(.dark *){
  fill: #98A2B3;
}

.dark\\:fill-gray-800:is(.dark *){
  fill: #1D2939;
}

.dark\\:stroke-gray-400:is(.dark *){
  stroke: #98A2B3;
}

.dark\\:text-blue-light-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(11 165 236 / var(--tw-text-opacity, 1));
}

.dark\\:text-brand-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(117 146 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-error-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}

.dark\\:text-error-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(228 231 236 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(71 84 103 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 133 58 / var(--tw-text-opacity, 1));
}

.dark\\:text-success-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(50 213 131 / var(--tw-text-opacity, 1));
}

.dark\\:text-success-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(18 183 106 / var(--tw-text-opacity, 1));
}

.dark\\:text-warning-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-white\\/60:is(.dark *){
  color: rgb(255 255 255 / 0.6);
}

.dark\\:text-white\\/80:is(.dark *){
  color: rgb(255 255 255 / 0.8);
}

.dark\\:text-white\\/90:is(.dark *){
  color: rgb(255 255 255 / 0.9);
}

.dark\\:ring-gray-700:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 64 84 / var(--tw-ring-opacity, 1));
}

.dark\\:file\\:border-gray-800:is(.dark *)::file-selector-button{
  --tw-border-opacity: 1;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1));
}

.dark\\:file\\:bg-white\\/\\[0\\.03\\]:is(.dark *)::file-selector-button{
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:file\\:text-gray-400:is(.dark *)::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder\\:text-gray-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder\\:text-white\\/30:is(.dark *)::placeholder{
  color: rgb(255 255 255 / 0.3);
}

.dark\\:placeholder\\:text-white\\/90:is(.dark *)::placeholder{
  color: rgb(255 255 255 / 0.9);
}

.dark\\:hover\\:border-brand-500:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(70 95 255 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-gray-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(29 41 57 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(52 64 84 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(29 41 57 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-white\\/5:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:hover\\:bg-white\\/\\[0\\.03\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:hover\\:text-gray-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(228 231 236 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(208 213 221 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:border-brand-300:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(156 185 255 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-brand-800:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(37 45 174 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-error-800:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(145 32 24 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:outline-none:focus:is(.dark *){
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.dark\\:focus\\:ring-0:focus:is(.dark *){
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.dark\\:focus\\:ring-transparent:focus:is(.dark *){
  --tw-ring-color: transparent;
}

.group:hover .dark\\:group-hover\\:fill-gray-300:is(.dark *){
  fill: #D0D5DD;
}

@media (min-width: 375px){

  .\\32xsm\\:w-\\[307px\\]{
    width: 307px;
  }

  .\\32xsm\\:gap-3{
    gap: 0.75rem;
  }
}

@media (min-width: 425px){

  .xsm\\:w-\\[358px\\]{
    width: 358px;
  }
}

@media (min-width: 640px){

  .sm\\:right-6{
    right: 1.5rem;
  }

  .sm\\:top-6{
    top: 1.5rem;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:mb-8{
    margin-bottom: 2rem;
  }

  .sm\\:ml-4{
    margin-left: 1rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-10{
    margin-top: 2.5rem;
  }

  .sm\\:mt-20{
    margin-top: 5rem;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:size-10{
    width: 2.5rem;
    height: 2.5rem;
  }

  .sm\\:size-4{
    width: 1rem;
    height: 1rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:w-11{
    width: 2.75rem;
  }

  .sm\\:w-\\[361px\\]{
    width: 361px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:max-w-\\[160px\\]{
    max-width: 160px;
  }

  .sm\\:max-w-\\[472px\\]{
    max-width: 472px;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:flex-1{
    flex: 1 1;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-5{
    gap: 1.25rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:gap-y-0{
    row-gap: 0px;
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-none{
    border-radius: 0px;
  }

  .sm\\:rounded-b-none{
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .sm\\:rounded-t-none{
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  .sm\\:border-0{
    border-width: 0px;
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pt-6{
    padding-top: 1.5rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-start{
    text-align: start;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-sm\\/6{
    font-size: 0.875rem;
    line-height: 1.5rem;
  }

  .sm\\:text-title-md{
    font-size: 36px;
    line-height: 44px;
  }

  .sm\\:text-xl\\/8{
    font-size: 1.25rem;
    line-height: 2rem;
  }
}

@media (min-width: 768px){

  .md\\:w-\\[668px\\]{
    width: 668px;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }
}

@media (min-width: 1024px){

  .lg\\:right-0{
    right: 0px;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .lg\\:ml-\\[290px\\]{
    margin-left: 290px;
  }

  .lg\\:ml-\\[90px\\]{
    margin-left: 90px;
  }

  .lg\\:mt-0{
    margin-top: 0px;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:inline-flex{
    display: inline-flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-11{
    height: 2.75rem;
  }

  .lg\\:w-11{
    width: 2.75rem;
  }

  .lg\\:w-\\[634px\\]{
    width: 634px;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:max-w-4xl{
    max-width: 56rem;
  }

  .lg\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:justify-normal{
    justify-content: normal;
  }

  .lg\\:justify-start{
    justify-content: flex-start;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:justify-center{
    justify-content: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-7{
    gap: 1.75rem;
  }

  .lg\\:rounded-bl-3xl{
    border-bottom-left-radius: 1.5rem;
  }

  .lg\\:rounded-bl-none{
    border-bottom-left-radius: 0px;
  }

  .lg\\:rounded-tr-3xl{
    border-top-right-radius: 1.5rem;
  }

  .lg\\:rounded-tr-none{
    border-top-right-radius: 0px;
  }

  .lg\\:border{
    border-width: 1px;
  }

  .lg\\:border-b{
    border-bottom-width: 1px;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:p-10{
    padding: 2.5rem;
  }

  .lg\\:p-11{
    padding: 2.75rem;
  }

  .lg\\:p-6{
    padding: 1.5rem;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1280px){

  .xl\\:order-2{
    order: 2;
  }

  .xl\\:order-3{
    order: 3;
  }

  .xl\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .xl\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .xl\\:block{
    display: block;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:w-\\[393px\\]{
    width: 393px;
  }

  .xl\\:w-\\[430px\\]{
    width: 430px;
  }

  .xl\\:min-w-full{
    min-width: 100%;
  }

  .xl\\:max-w-\\[450px\\]{
    max-width: 450px;
  }

  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:justify-end{
    justify-content: flex-end;
  }

  .xl\\:justify-between{
    justify-content: space-between;
  }

  .xl\\:gap-3{
    gap: 0.75rem;
  }

  .xl\\:p-10{
    padding: 2.5rem;
  }

  .xl\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .xl\\:text-left{
    text-align: left;
  }

  .xl\\:text-title-2xl{
    font-size: 72px;
    line-height: 90px;
  }

  .xl\\:text-title-lg{
    font-size: 48px;
    line-height: 60px;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:w-\\[554px\\]{
    width: 554px;
  }

  .\\32xl\\:gap-x-32{
    column-gap: 8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,+BAAc;EAAd,eAAc;EAAd,mBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AA2DhB;EAAA,kBAA6F;EAA7F,aAA6F;EAA7F,WAA6F;EAA7F,mBAA6F;EAA7F,YAA6F;EAA7F,qBAA6F;EAA7F,qBAA6F;EAA7F,sBAA6F;EAA7F,mBAA6F;EAA7F,sBAA6F;EAA7F,eAA6F;EAA7F,iBAA6F;EAA7F;AAA6F;AAA7F;EAAA,mBAA6F;AAAA;AAG7F;EAAA,kBAA8E;EAA9E,4DAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;AAA9E;EAAA,uCAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;AAG9E;EAAA,oBAAkI;EAAlI;AAAkI;AAAlI;EAAA,kBAAkI;EAAlI;AAAkI;AAAlI;EAAA,oBAAkI;EAAlI;AAAkI;AAAlI;EAAA,oBAAkI;EAAlI;AAAkI;AAAlI;EAAA,yCAAkI;EAAlI,oBAAkI;EAAlI;AAAkI;AAMlI;EAAA,oBAAyC;EAAzC;AAAyC;AAAzC;EAAA,oBAAyC;EAAzC;AAAyC;AAGzC;EAAA,oBAAgG;EAAhG;AAAgG;AAAhG;EAAA,oBAAgG;EAAhG;AAAgG;AAAhG;EAAA,oBAAgG;EAAhG;AAAgG;AAAhG;EAAA,oBAAgG;EAAhG;AAAgG;AAchG;EAAA,kBAAwF;EAAxF,aAAwF;EAAxF,mBAAwF;EAAxF,YAAwF;EAAxF,qBAAwF;EAAxF,qBAAwF;EAAxF,sBAAwF;EAAxF,qBAAwF;EAAxF,wBAAwF;EAAxF,eAAwF;EAAxF,iBAAwF;EAAxF;AAAwF;AAAxF;EAAA,mBAAwF;AAAA;AAGxF;EAAA,kBAA8E;EAA9E,4DAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;AAA9E;EAAA,uCAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;AAG9E;EAAA,oBAA+E;EAA/E;AAA+E;AAA/E;EAAA,kBAA+E;EAA/E;AAA+E;AAA/E;EAAA,oBAA+E;EAA/E;AAA+E;AAA/E;EAAA;AAA+E;AAI/E;EAAA,cAAwG;EAAxG,qBAAwG;EAAxG,sBAAwG;EAAxG,uBAAwG;EAAxG,qBAAwG;EAAxG,wBAAwG;EAAxG,kBAAwG;EAAxG,iBAAwG;EAAxG,gBAAwG;EAAxG,yBAAwG;EAAxG,oBAAwG;EAAxG;AAAwG;AAAxG;EAAA,oBAAwG;EAAxG;AAAwG;AAGxG;EAAA,kBAAwC;EAAxC;AAAwC;AAAxC;EAAA;AAAwC;AAGxC;EAAA,kBAAiG;EAAjG;AAAiG;AAAjG;EAAA,kBAAiG;EAAjG;AAAiG;AAAjG;EAAA;AAAiG;AAAjG;EAAA;AAAiG;AAvGrG;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,uGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6FAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA2GjB,6BAA6B;AAC7B;IACE,aAAa;EACf;AAEA;IACE,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;EACrC;AAGE;EAAA,eAAe;EAAf;AAAe;AAIf;EAAA;AAAmB;AAInB;EAAA,qBAAgD;EAAhD,kBAAgD;EAAhD;AAAgD;AAAhD;EAAA,kBAAgD;EAAhD;AAAgD;AAElD,yBAAyB;AACzB;;;;IAIE,aAAa;IACb,wBAAwB;EAC1B;;AA/HF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+CG;;AAoFD;EAAA;AAAkB;AAGlB;EAAA,sBAAoC;EAApC,0DAAoC;EAApC,kBAAoC;EAApC;AAAoC;;AAGtC,8BAA8B;AAE5B;EAAA,+BAAyC;EAAzC;AAAyC;AAAzC;EAAA,+BAAyC;EAAzC;AAAyC;;AAIzC;EAAA;AAAyC;;AAAzC;EAAA;AAAyC;;AAIzC;EAAA,YAAsG;EAAtG,gCAAsG;EAAtG,iCAAsG;EAAtG,uEAAsG;EAAtG,gBAAsG;EAAtG,sGAAsG;EAAtG,8GAAsG;EAAtG;AAAsG;;AAAtG;EAAA,iCAAsG;EAAtG,oEAAsG;EAAtG,6BAAsG;EAAtG;AAAsG;;AAItG;EAAA,iCAA4B;EAA5B,2BAA4B;EAA5B;AAA4B;AAG5B;EAAA,gCAA+C;EAA/C,+BAA+C;EAA/C;AAA+C;AAA/C;EAAA,+BAA+C;EAA/C;AAA+C;AAG/C;EAAA;AAAW;AAGX;EAAA;AAAW;AAGX;EAAA,6BAAwG;EAAxG,mCAAwG;EAAxG,wCAAwG;EAAxG,uBAAwG;EAAxG,0BAAwG;EAAxG,4BAAwG;EAAxG,+BAAwG;EAAxG;AAAwG;AAAxG;EAAA;AAAwG;AAGxG;EAAA,0BAAwD;EAAxD,4BAAwD;EAAxD,+BAAwD;EAAxD;AAAwD;AAAxD;EAAA;AAAwD;AAGxD;EAAA;AAAmB;;AAInB;EAAA;AAA6C;;AAA7C;EAAA;AAA6C;AAG7C;EAAA,kCAAuB;EAAvB;AAAuB;AAGvB;EAAA,wBAAwD;EAAxD;AAAwD;AAAxD;EAAA;AAAwD;;AAIxD;EAAA,uBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,6BAAoC;EAApC;AAAoC;;AAApC;EAAA,6BAAoC;EAApC;AAAoC;AAGpC;EAAA;AAA0F;AAA1F;EAAA;AAA0F;AAA1F;EAAA;AAA0F;AAA1F;EAAA;AAA0F;AAG1F;EAAA;AAA6C;AAA7C;EAAA;AAA6C;AAG7C;EAAA,6BAA6C;EAA7C,6BAA6C;EAA7C,qEAA6C;EAA7C,+BAA6C;EAA7C,gCAA6C;EAA7C,+BAA6C;EAA7C;AAA6C;AAI7C;;EAAA;AAAc;;AAKd;;EAAA;AAAa;;AAKb;;EAAA,2BAA+N;EAA/N,eAA+N;EAA/N,YAA+N;EAA/N,cAA+N;EAA/N,qBAA+N;EAA/N,iBAA+N;EAA/N,sBAA+N;EAA/N,4DAA+N;EAA/N,+BAA+N;EAA/N,2DAA+N;EAA/N,wJAA+N;EAA/N,wDAA+N;EAA/N;AAA+N;;AAA/N;;EAAA,kBAA+N;EAA/N;AAA+N;;AAA/N;;EAAA,qCAA+N;EAA/N,kBAA+N;EAA/N,yDAA+N;EAA/N,+BAA+N;EAA/N;AAA+N;;AAA/N;;EAAA,yCAA+N;EAA/N;AAA+N;;AAK/N;;EAAA,kBAA2C;EAA3C,4DAA2C;EAA3C;AAA2C;;AAA3C;;EAAA,kBAA2C;EAA3C;AAA2C;;AAK3C;;EAAA,uBAAsB;EAAtB;AAAsB;;AAItB;EAAA;AAAa;AAGb;EAAA,kBAAwJ;EAAxJ,iCAAwJ;EAAxJ,4BAAwJ;EAAxJ,iCAAwJ;EAAxJ,uEAAwJ;EAAxJ,6BAAwJ;EAAxJ,uEAAwJ;EAAxJ,2BAAwJ;EAAxJ,+BAAwJ;EAAxJ;AAAwJ;AAAxJ;EAAA,6BAAwJ;EAAxJ,oEAAwJ;EAAxJ,+BAAwJ;EAAxJ,8DAAwJ;EAAxJ,0GAAwJ;EAAxJ,kHAAwJ;EAAxJ;AAAwJ;AAAxJ;;EAAA;IAAA;EAAwJ;AAAA;;AAKxJ;;EAAA;AAAuB;AAIvB;;EAAA;AAAa;;AAIb;EAAA;AAAW;AAIX;;EAAA,uBAA6E;EAA7E,2BAA6E;EAA7E,8BAA6E;EAA7E,+BAA6E;EAA7E,2BAA6E;EAA7E,+BAA6E;EAA7E;AAA6E;AAA7E;;EAAA;AAA6E;;AAK7E;;EAAA;AAAW;;AAIX;EAAA,kBAAuC;EAAvC,mBAAuC;EAAvC,YAAuC;EAAvC;AAAuC;;AAIvC;EAAA,wCAAqF;EAArF,0BAAqF;EAArF,4BAAqF;EAArF,2BAAqF;EAArF,+BAAqF;EAArF;AAAqF;;AAArF;EAAA,+BAAqF;EAArF;AAAqF;;AAIrF;EAAA,wBAA6I;EAA7I,8BAA6I;EAA7I,0BAA6I;EAA7I,4BAA6I;EAA7I,2BAA6I;EAA7I,+BAA6I;EAA7I;AAA6I;;AAA7I;EAAA;AAA6I;;AAA7I;EAAA,iCAA6I;EAA7I,uEAA6I;EAA7I,6BAA6I;EAA7I;AAA6I;AAI7I;;EAAA,+BAAqB;EAArB;AAAqB;;AAGvB;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;;;EAGE,wBAAwB;EACxB,oBAAoB;AACtB;AAGE;;EAAA,uBAA+D;EAA/D;AAA+D;AAA/D;;EAAA,wBAA+D;EAA/D,+BAA+D;EAA/D;AAA+D;AAI/D;;EAAA;AAAc;AAId;;EAAA;AAAe;AAGf;EAAA;AAAgB;AAIhB;;EAAA;AAAiD;AAAjD;;EAAA,wBAAiD;EAAjD,+BAAiD;EAAjD;AAAiD;AAGjD;EAAA;AAAkB;AAGlB;EAAA;AAAe;AAEjB;EACE,wDAAwD;AAE1D;AADE;EAAA,yDAA8B;EAA9B,+FAA8B;EAA9B;AAA8B;AAc9B;;;;;;;;;;;;EAAA,iCAAuF;EAAvF,uEAAuF;EAAvF,6BAAuF;EAAvF;AAAuF;AAAvF;;;;;;;;;;;;EAAA,4BAAuF;EAAvF,gDAAuF;EAAvF;AAAuF;AAMvF;;;;EAAA,+BAAmC;EAAnC;AAAmC;AAAnC;;;;EAAA,+BAAmC;EAAnC;AAAmC;AAErC;;;;;;;;;;;;;;;;;;EAkBE,mBAAmB;EACnB,iCAAkF;EAAlF,qEAAkF;EAAlF,6BAAkF;EAAlF,qEAAkF;AACpF;AADE;;;;;;;;;;;;;;;;;;EAAA,iCAAkF;EAAlF,qEAAkF;EAAlF,6BAAkF;EAAlF;AAAkF;AAEpF;;;EAGE,6BAA6B;AAC/B;;AAME;;;;EAAA;AAAuB;AAEzB;;EAEE,qBAAqB;AACvB;;AAGE;EAAA;AAAc;;AAId;EAAA,eAAkD;EAAlD;AAAkD;;AAAlD;EAAA,eAAkD;EAAlD;AAAkD;;AAAlD;EAAA;AAAkD;;AAAlD;EAAA,qBAAkD;EAAlD,kBAAkD;EAAlD;AAAkD;;AAAlD;EAAA,kBAAkD;EAAlD;AAAkD;AAGlD;EAAA;AAAoB;AAEtB;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AAEE;EAAA,sBAA2C;EAA3C,SAA2C;EAA3C,oBAA2C;EAA3C,qBAA2C;EAA3C;AAA2C;AAA3C;;EAAA;IAAA;EAA2C;AAAA;AAG3C;EAAA;AAAY;AAGZ;EAAA,aAAmU;EAAnU,cAAmU;EAAnU,aAAmU;EAAnU,mBAAmU;EAAnU,uBAAmU;EAAnU,gCAAmU;EAAnU,iBAAmU;EAAnU,sBAAmU;EAAnU,4DAAmU;EAAnU;AAAmU;AAAnU;EAAA,mBAAmU;AAAA;AAAnU;EAAA,sBAAmU;EAAnU,4DAAmU;EAAnU,kBAAmU;EAAnU;AAAmU;AAAnU;EAAA,sBAAmU;EAAnU,8BAAmU;EAAnU;AAAmU;AAAnU;EAAA,iCAAmU;EAAnU,uEAAmU;EAAnU,wCAAmU;EAAnU,iCAAmU;EAAnU,yCAAmU;EAAnU;AAAmU;AAAnU;EAAA,sBAAmU;EAAnU;AAAmU;AAAnU;EAAA,sBAAmU;EAAnU,yDAAmU;EAAnU,kBAAmU;EAAnU;AAAmU;AAAnU;EAAA,iCAAmU;EAAnU;AAAmU;;AAInU;EAAA,mBAAwB;EAAxB,qBAAwB;EACxB;AADwB;AAIxB;EAAA,mBAAwB;EAAxB,qBAAwB;EACxB;AADwB;AAG1B;EACE,gDAA6R;AAC/R;AACA;EACE,gDAA6R;AAC/R;AAEE;EAAA;AAAa;AAGb;EAAA,gCAAqH;EAArH,4BAAqH;EAArH,6BAAqH;EAArH,qEAAqH;EAArH,6BAAqH;EAArH,8BAAqH;EAArH,gCAAqH;EAArH,mCAAqH;EAArH,8BAAqH;EAArH,+BAAqH;EAArH;AAAqH;AAArH;EAAA,6BAAqH;EAArH;AAAqH;AAArH;EAAA,iCAAqH;EAArH,yCAAqH;EAArH;AAAqH;AAGrH;EAAA,8BAA6D;EAA7D,+BAA6D;EAA7D,2BAA6D;EAA7D,oBAA6D;EAA7D;AAA6D;AAA7D;EAAA;AAA6D;AAG7D;EAAA,qBAAoD;EAApD,kBAAoD;EAApD,4DAAoD;EAApD;AAAoD;AAApD;EAAA,kBAAoD;EAApD;AAAoD;AAGpD;EAAA,uBAAkK;EAAlK,sBAAkK;EAAlK,uBAAkK;EAAlK,4BAAkK;EAAlK,6BAAkK;EAAlK,gCAAkK;EAAlK,iCAAkK;EAAlK,8BAAkK;EAAlK,iCAAkK;EAAlK,mBAAkK;EAAlK,oBAAkK;EAAlK,gBAAkK;EAAlK,oBAAkK;EAAlK;AAAkK;AAAlK;EAAA,oBAAkK;EAAlK;AAAkK;AAAlK;EAAA,iCAAkK;EAAlK,yCAAkK;EAAlK;AAAkK;AAAlK;EAAA,oBAAkK;EAAlK;AAAkK;AAKlK;;;EAAA,kBAA8D;EAA9D,4DAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;AAA9D;;;EAAA,kBAA8D;EAA9D,yDAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;AAG9D;EAAA,iCAAyG;EAAzG,kCAAyG;EAAzG,qBAAyG;EAAzG,iCAAyG;EAAzG,uEAAyG;EAAzG,kBAAyG;EAAzG,4DAAyG;EAAzG;AAAyG;AAAzG;EAAA,iCAAyG;EAAzG,oEAAyG;EAAzG,kBAAyG;EAAzG;AAAyG;AAIzG;;EAAA,iCAA6C;EAA7C;AAA6C;AAA7C;;EAAA,iCAA6C;EAA7C;AAA6C;AAG7C;EAAA,gCAA8D;EAA9D,iCAA8D;EAA9D,4BAA8D;EAA9D,+BAA8D;EAA9D,mBAA8D;EAA9D,oBAA8D;EAA9D,gBAA8D;EAA9D,yBAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;AAG9D;EAAA;AAAqB;AAGrB;EAAA;AAAU;AAGV;EAAA,sBAA+C;EAA/C,kBAA+C;EAA/C;AAA+C;AAA/C;EAAA;AAA+C;AAG/C;EAAA,2BAAgE;EAAhE,mBAAgE;EAAhE,oBAAgE;EAAhE,gBAAgE;EAAhE,oBAAgE;EAAhE;AAAgE;AAAhE;EAAA,oBAAgE;EAAhE;AAAgE;AAGhE;EAAA;AAAgB;AAElB;EACE,UAAU;AACZ;AAEE;EAAA,oBAAuC;EAAvC;AAAuC;AAAvC;EAAA;AAAuC;AAGvC;EAAA,qBAAkC;EAAlC,qBAAkC;EAAlC,wBAAkC;EAAlC,kBAAkC;EAAlC;AAAkC;AAGlC;EAAA,YAA4C;EAA5C,mBAA4C;EAA5C,oBAA4C;EAA5C,gBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;AAG5C;EAAA,gBAA4C;EAA5C,qBAA4C;EAA5C,eAA4C;EAA5C,cAA4C;EAA5C,sBAA4C;EAA5C;AAA4C;AAG5C;EAAA,sBAAwB;EAAxB,8BAAwB;EAAxB;AAAwB;AAGxB;EAAA;AAAY;AAGZ;EAAA,sBAAsC;EAAtC,4DAAsC;EAAtC,kBAAsC;EAAtC;AAAsC;AAGtC;EAAA,sBAAkC;EAAlC,4DAAkC;EAAlC,kBAAkC;EAAlC;AAAkC;AAGlC;EAAA,sBAAkC;EAAlC,4DAAkC;EAAlC,kBAAkC;EAAlC;AAAkC;AAGlC;EAAA,sBAAoC;EAApC,4DAAoC;EAApC,kBAAoC;EAApC;AAAoC;AAGpC;EAAA,kBAAqB;EAArB;AAAqB;AAGrB;EAAA,kBAAmB;EAAnB;AAAmB;AAGnB;EAAA,kBAAmB;EAAnB;AAAmB;AAGnB;EAAA,kBAAoB;EAApB;AAAoB;AAGpB;EAAA,qBAAiF;EAAjF,sBAAiF;EAAjF,qBAAiF;EAAjF,wBAAiF;EAAjF,gBAAiF;EAAjF,mBAAiF;EAAjF,oBAAiF;EAAjF,gBAAiF;EAAjF,oBAAiF;EAAjF;AAAiF;AAAjF;EAAA,oBAAiF;EAAjF;AAAiF;AAGjF;EAAA,mBAA2D;EAA3D,oBAA2D;EAA3D,gBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;AAA3D;EAAA,oBAA2D;EAA3D;AAA2D;;AAG7D;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAIE;;EAAA,uBAAsB;EAAtB;AAAsB;;AAOtB;;;;EAAA;AAAa;AAMb;;;;EAAA,wCAA+B;EAA/B;AAA+B;AAM/B;;;;EAAA,cAAqI;EAArI,aAAqI;EAArI,qBAAqI;EAArI,mBAAqI;EAArI,oCAAqI;EAArI,wCAAqI;EAArI,+BAAqI;EAArI,2DAAqI;EAArI,2FAAqI;EAArI,mGAAqI;EAArI,uGAAqI;EAArI,8BAAqI;EAArI;AAAqI;;AAKrI;;EAAA;AAAyB;;AAAzB;;EAAA;;IAAA;EAAyB;AAAA;;AAKzB;;EAAA;AAA2B;;AAA3B;;EAAA;;IAAA;EAA2B;AAAA;;AAK3B;;EAAA,0BAAqN;EAArN,oBAAqN;EAArN,oBAAqN;EAArN,sBAAqN;EAArN,sBAAqN;EAArN,+LAAqN;EAArN,mBAAqN;EAArN,aAAqN;EAArN,mBAAqN;EAArN,mBAAqN;EAArN,oCAAqN;EAArN,wCAAqN;EAArN,oBAAqN;EAArN,qBAAqN;EAArN,qBAAqN;EAArN,wBAAqN;EAArN,2FAAqN;EAArN,mGAAqN;EAArN,uGAAqN;EAArN,8BAAqN;EAArN;AAAqN;;AAArN;;EAAA;;IAAA;EAAqN;AAAA;;AAKrN;;EAAA,sBAAqF;EAArF,gBAAqF;EAArF,eAAqF;EAArF,kBAAqF;EAArF,4DAAqF;EAArF,UAAqF;EAArF,mDAAqF;EAArF,2DAAqF;EAArF,uGAAqF;EAArF,0BAAqF;EAArF;AAAqF;;AAKrF;;EAAA,eAAuB;EAAvB;AAAuB;;AAIvB;EAAA,iBAAuE;EAAvE,sBAAuE;EAAvE,0DAAuE;EAAvE,kBAAuE;EAAvE;AAAuE;;AAAvE;EAAA,sBAAuE;EAAvE;AAAuE;;AAIvE;EAAA,kBAA+B;EAA/B,0DAA+B;EAA/B;AAA+B;AAG/B;EAAA,oBAAiC;EAAjC,mDAAiC;EAAjC;AAAiC;AAGjC;EAAA,sBAA0D;EAA1D,0DAA0D;EAA1D,kBAA0D;EAA1D;AAA0D;AAA1D;EAAA,sBAA0D;EAA1D;AAA0D;;AAG5D;EACE,yBAAyB,EAAE,yCAAyC;EAIpE,sBAAsB;EACtB;0CACwC;EACxC,YAAY;EACZ,gBAAgB,EAAE,4CAA4C;AAPhE;;AAUA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;AACd;AAEE;EAAA;AAAmB;AAErB;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAnnBA;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,8BAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,mBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oDAmnBC;EAnnBD,2DAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,8BAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,2GAmnBC;EAnnBD,yGAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,2GAmnBC;EAnnBD,yGAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,2GAmnBC;EAnnBD,yGAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,kBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,oBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,sBAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,8BAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA,2GAmnBC;EAnnBD,yGAmnBC;EAnnBD;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;EAAA;AAmnBC;;AAnnBD;;EAAA;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;AAAA;;AAnnBD;;EAAA;IAAA;EAmnBC;AAAA;;AAnnBD;;EAAA;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,oBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,gBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,gBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,aAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,WAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,uBAmnBC;IAnnBD,8DAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,+BAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,2BAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,qBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,oBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,mBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,mBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,oBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,kBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,eAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,mBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,mBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,mBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,eAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,kBAmnBC;IAnnBD;EAmnBC;AAAA;;AAnnBD;;EAAA;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;AAAA;;AAnnBD;;EAAA;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,gBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,qBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,oBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,kBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,sBAmnBC;IAnnBD,8BAmnBC;IAnnBD;EAmnBC;AAAA;;AAnnBD;;EAAA;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,oBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,iBAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA;EAmnBC;;EAnnBD;IAAA,eAmnBC;IAnnBD;EAmnBC;;EAnnBD;IAAA,eAmnBC;IAnnBD;EAmnBC;AAAA;;AAnnBD;;EAAA;IAAA;EAmnBC;;EAnnBD;IAAA;EAmnBC;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  body {\n    @apply relative text-base font-normal z-1 bg-gray-50 font-outfit;\n  }\n}\n\n/* @layer components {\n  .menu-item {\n    @apply relative flex items-center gap-3 px-3 py-2 font-medium rounded-lg text-theme-sm;\n  }\n  .menu-item-active {\n    @apply bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400;\n  }\n  .menu-item-inactive {\n    @apply text-gray-700 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-gray-300;\n  }\n\n  .menu-item-icon-active {\n    @apply text-brand-500 dark:text-brand-400;\n  }\n  .menu-item-icon-inactive {\n    @apply text-gray-500 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300;\n  }\n\n  .menu-item-arrow {\n    @apply absolute right-2.5 top-1/2 -translate-y-1/2;\n  }\n  .menu-item-arrow-active {\n    @apply rotate-180 stroke-brand-500 dark:stroke-brand-400;\n  }\n  .menu-item-arrow-inactive {\n    @apply stroke-gray-500 group-hover:stroke-gray-700 dark:stroke-gray-400 dark:group-hover:stroke-gray-300;\n  }\n\n  .menu-dropdown-item {\n    @apply relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-theme-sm font-medium;\n  }\n  .menu-dropdown-item-active {\n    @apply bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400;\n  }\n  .menu-dropdown-item-inactive {\n    @apply text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5;\n  }\n\n  .menu-dropdown-badge {\n    @apply block rounded-full px-2.5 py-0.5 text-xs font-medium uppercase text-brand-500 dark:text-brand-400;\n  }\n  .menu-dropdown-badge-active {\n    @apply bg-brand-100 dark:bg-brand-500/20;\n  }\n  .menu-dropdown-badge-inactive {\n    @apply bg-brand-50 group-hover:bg-brand-100 dark:bg-brand-500/15 dark:group-hover:bg-brand-500/20;\n  }\n} */\n@layer components {\n  .menu-item {\n    @apply relative flex items-center w-full gap-3 px-3 py-2 font-medium rounded-lg text-theme-sm;\n  }\n  .menu-item-active {\n    @apply bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400;\n  }\n  .menu-item-inactive {\n    @apply text-gray-700 hover:bg-gray-100 group-hover:text-gray-700 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-gray-300;\n  }\n  .menu-item-icon {\n    @apply text-gray-500 group-hover:text-gray-700 dark:text-gray-400;\n  }\n  .menu-item-icon-active {\n    @apply text-brand-500 dark:text-brand-400;\n  }\n  .menu-item-icon-inactive {\n    @apply text-gray-500 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300;\n  }\n\n  .menu-item-arrow {\n    @apply relative;\n  }\n  .menu-item-arrow-active {\n    @apply rotate-180 text-brand-500 dark:text-brand-400;\n  }\n  .menu-item-arrow-inactive {\n    @apply text-gray-500 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300;\n  }\n\n  .menu-dropdown-item {\n    @apply relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-theme-sm font-medium;\n  }\n  .menu-dropdown-item-active {\n    @apply bg-brand-50 text-brand-500 dark:bg-brand-500/[0.12] dark:text-brand-400;\n  }\n  .menu-dropdown-item-inactive {\n    @apply text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5;\n  }\n\n  .menu-dropdown-badge {\n    @apply block rounded-full px-2.5 py-0.5 text-xs font-medium uppercase text-brand-500 dark:text-brand-400;\n  }\n  .menu-dropdown-badge-active {\n    @apply bg-brand-100 dark:bg-brand-500/20;\n  }\n  .menu-dropdown-badge-inactive {\n    @apply bg-brand-50 group-hover:bg-brand-100 dark:bg-brand-500/15 dark:group-hover:bg-brand-500/20;\n  }\n}\n@layer utilities {\n  /* Chrome, Safari and Opera */\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n\n  .no-scrollbar {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n\n  .custom-scrollbar::-webkit-scrollbar {\n    @apply size-1.5;\n  }\n\n  .custom-scrollbar::-webkit-scrollbar-track {\n    @apply rounded-full;\n  }\n\n  .custom-scrollbar::-webkit-scrollbar-thumb {\n    @apply bg-gray-200 rounded-full dark:bg-gray-700;\n  }\n  /* For Remove Date Icon */\n  input[type=\"date\"]::-webkit-inner-spin-button,\n  input[type=\"time\"]::-webkit-inner-spin-button,\n  input[type=\"date\"]::-webkit-calendar-picker-indicator,\n  input[type=\"time\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n  }\n}\n\n.tableCheckbox:checked ~ span span {\n  @apply opacity-100;\n}\n.tableCheckbox:checked ~ span {\n  @apply border-brand-500 bg-brand-500;\n}\n\n/* third-party libraries CSS */\n.apexcharts-legend-text {\n  @apply !text-gray-700 dark:!text-gray-400;\n}\n\n.apexcharts-text {\n  @apply !fill-gray-700 dark:!fill-gray-400;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  @apply gap-1 !rounded-lg !border-gray-200 p-3 !shadow-theme-sm dark:!border-gray-800 dark:!bg-gray-900;\n}\n\n.apexcharts-tooltip-marker {\n  @apply !mr-1.5 !h-1.5 !w-1.5;\n}\n.apexcharts-legend-text {\n  @apply !pl-5 !text-gray-700 dark:!text-gray-400;\n}\n.apexcharts-tooltip-series-group {\n  @apply !p-0;\n}\n.apexcharts-tooltip-y-group {\n  @apply !p-0;\n}\n.apexcharts-tooltip-title {\n  @apply !mb-0 !border-b-0 !bg-transparent !p-0 !text-[10px] !leading-4 !text-gray-800 dark:!text-white/90;\n}\n.apexcharts-tooltip-text {\n  @apply !text-theme-xs !text-gray-700 dark:!text-white/90;\n}\n.apexcharts-tooltip-text-y-value {\n  @apply !font-medium;\n}\n\n.apexcharts-gridline {\n  @apply !stroke-gray-100 dark:!stroke-gray-800;\n}\n#chartTwo .apexcharts-datalabels-group {\n  @apply !-translate-y-24;\n}\n#chartTwo .apexcharts-datalabels-group .apexcharts-text {\n  @apply !fill-gray-800 !font-semibold dark:!fill-white/90;\n}\n\n#chartSixteen .apexcharts-legend {\n  @apply !p-0 !pl-6;\n}\n\n.jvectormap-container {\n  @apply !bg-gray-50 dark:!bg-gray-900;\n}\n.jvectormap-region.jvectormap-element {\n  @apply !fill-gray-300 hover:!fill-brand-500 dark:!fill-gray-700 dark:hover:!fill-brand-500;\n}\n.jvectormap-marker.jvectormap-element {\n  @apply !stroke-gray-200 dark:!stroke-gray-800;\n}\n.jvectormap-tip {\n  @apply !bg-brand-500 !border-none !px-2 !py-1;\n}\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  @apply !hidden;\n}\n\n.stocks-slider-outer .swiper-button-next:after,\n.stocks-slider-outer .swiper-button-prev:after {\n  @apply hidden;\n}\n\n.stocks-slider-outer .swiper-button-next,\n.stocks-slider-outer .swiper-button-prev {\n  @apply !static mt-0 h-8 w-9 rounded-full border dark:hover:bg-white/[0.05] border-gray-200 !text-gray-700 transition hover:bg-gray-100 dark:border-white/[0.03] dark:bg-gray-800 dark:!text-gray-400  dark:hover:!text-white/90;\n}\n\n.stocks-slider-outer .swiper-button-next.swiper-button-disabled,\n.stocks-slider-outer .swiper-button-prev.swiper-button-disabled {\n  @apply bg-white opacity-50 dark:bg-gray-900;\n}\n\n.stocks-slider-outer .swiper-button-next svg,\n.stocks-slider-outer .swiper-button-prev svg {\n  @apply !h-auto !w-auto;\n}\n\n.flatpickr-wrapper {\n  @apply w-full;\n}\n.flatpickr-calendar {\n  @apply mt-2 !bg-white !rounded-xl !p-5 !border !border-gray-200 !text-gray-500 dark:!bg-gray-dark dark:!text-gray-400 dark:!shadow-theme-xl 2xsm:!w-auto;\n}\n\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  @apply stroke-brand-500;\n}\n.flatpickr-calendar.arrowTop:before,\n.flatpickr-calendar.arrowTop:after {\n  @apply hidden;\n}\n\n.flatpickr-current-month {\n  @apply !p-0;\n}\n.flatpickr-current-month .cur-month,\n.flatpickr-current-month input.cur-year {\n  @apply !h-auto !pt-0 !text-lg !font-medium !text-gray-800 dark:!text-white/90;\n}\n\n.flatpickr-prev-month,\n.flatpickr-next-month {\n  @apply !p-0;\n}\n\n.flatpickr-weekdays {\n  @apply h-auto mt-6 mb-4 !bg-transparent;\n}\n\n.flatpickr-weekday {\n  @apply !text-theme-sm !font-medium !text-gray-500 dark:!text-gray-400 !bg-transparent;\n}\n\n.flatpickr-day {\n  @apply !flex !items-center !text-theme-sm !font-medium !text-gray-800 dark:!text-white/90 dark:hover:!border-gray-300 dark:hover:!bg-gray-900;\n}\n.flatpickr-day.nextMonthDay,\n.flatpickr-day.prevMonthDay {\n  @apply !text-gray-400;\n}\n\n.flatpickr-months > .flatpickr-month {\n  background: none !important;\n}\n.flatpickr-month .flatpickr-current-month .flatpickr-monthDropdown-months {\n  background: none !important;\n  appearance: none;\n  background-image: none !important;\n  font-weight: 500;\n}\n.flatpickr-month\n  .flatpickr-current-month\n  .flatpickr-monthDropdown-months:focus {\n  outline: none !important;\n  border: 0 !important;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  @apply !top-7 dark:!fill-white dark:!text-white !bg-transparent;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n  @apply !left-7;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n  @apply !right-7;\n}\n.flatpickr-days {\n  @apply !border-0;\n}\nspan.flatpickr-weekday,\n.flatpickr-months .flatpickr-month {\n  @apply dark:!fill-white dark:!text-white !bg-none;\n}\n.flatpickr-innerContainer {\n  @apply !border-b-0;\n}\n.flatpickr-months .flatpickr-month {\n  @apply !bg-none;\n}\n.flatpickr-day.inRange {\n  box-shadow: -5px 0 0 #f9fafb, 5px 0 0 #f9fafb !important;\n  @apply dark:!shadow-datepicker;\n}\n.flatpickr-day.inRange,\n.flatpickr-day.prevMonthDay.inRange,\n.flatpickr-day.nextMonthDay.inRange,\n.flatpickr-day.today.inRange,\n.flatpickr-day.prevMonthDay.today.inRange,\n.flatpickr-day.nextMonthDay.today.inRange,\n.flatpickr-day:hover,\n.flatpickr-day.prevMonthDay:hover,\n.flatpickr-day.nextMonthDay:hover,\n.flatpickr-day:focus,\n.flatpickr-day.prevMonthDay:focus,\n.flatpickr-day.nextMonthDay:focus {\n  @apply !border-gray-50 !bg-gray-50 dark:!border-0 dark:!border-white/5 dark:!bg-white/5;\n}\n.flatpickr-day.selected,\n.flatpickr-day.startRange,\n.flatpickr-day.selected,\n.flatpickr-day.endRange {\n  @apply !text-white dark:!text-white;\n}\n.flatpickr-day.selected,\n.flatpickr-day.startRange,\n.flatpickr-day.endRange,\n.flatpickr-day.selected.inRange,\n.flatpickr-day.startRange.inRange,\n.flatpickr-day.endRange.inRange,\n.flatpickr-day.selected:focus,\n.flatpickr-day.startRange:focus,\n.flatpickr-day.endRange:focus,\n.flatpickr-day.selected:hover,\n.flatpickr-day.startRange:hover,\n.flatpickr-day.endRange:hover,\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.startRange.prevMonthDay,\n.flatpickr-day.endRange.prevMonthDay,\n.flatpickr-day.selected.nextMonthDay,\n.flatpickr-day.startRange.nextMonthDay,\n.flatpickr-day.endRange.nextMonthDay {\n  background: #465fff;\n  @apply !border-brand-500 !bg-brand-500 hover:!border-brand-500 hover:!bg-brand-500;\n}\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),\n.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)),\n.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)) {\n  box-shadow: -10px 0 0 #465fff;\n}\n\n.flatpickr-months .flatpickr-prev-month svg,\n.flatpickr-months .flatpickr-next-month svg,\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  @apply hover:!fill-none;\n}\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  fill: none !important;\n}\n\n.flatpickr-calendar.static {\n  @apply right-0;\n}\n\n.fc .fc-view-harness {\n  @apply max-w-full overflow-x-auto custom-scrollbar;\n}\n.fc-dayGridMonth-view.fc-view.fc-daygrid {\n  @apply min-w-[718px];\n}\n.fc .fc-scrollgrid-section > * {\n  border-right-width: 0;\n  border-bottom-width: 0;\n}\n.fc .fc-scrollgrid {\n  border-left-width: 0;\n}\n.fc .fc-toolbar.fc-header-toolbar {\n  @apply flex-col gap-4 px-6 pt-6 sm:flex-row;\n}\n.fc-button-group {\n  @apply gap-2;\n}\n.fc-button-group .fc-button {\n  @apply flex h-10 w-10 items-center justify-center !rounded-lg border border-gray-200 bg-transparent hover:border-gray-200 hover:bg-gray-50 focus:shadow-none active:!border-gray-200 active:!bg-transparent active:!shadow-none dark:border-gray-800 dark:hover:border-gray-800 dark:hover:bg-gray-900 dark:active:!border-gray-800;\n}\n\n.fc-button-group .fc-button.fc-prev-button:before {\n  @apply inline-block mt-1;\n  content: url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.0068 6L9.75684 12.25L16.0068 18.5' stroke='%23344054' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.fc-button-group .fc-button.fc-next-button:before {\n  @apply inline-block mt-1;\n  content: url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.50684 19L15.7568 12.75L9.50684 6.5' stroke='%23344054' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.dark .fc-button-group .fc-button.fc-prev-button:before {\n  content: url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.0068 6L9.75684 12.25L16.0068 18.5' stroke='%2398A2B3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.dark .fc-button-group .fc-button.fc-next-button:before {\n  content: url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.50684 19L15.7568 12.75L9.50684 6.5' stroke='%2398A2B3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.fc-button-group .fc-button .fc-icon {\n  @apply hidden;\n}\n.fc-addEventButton-button {\n  @apply !rounded-lg !border-0 !bg-brand-500 !px-4 !py-2.5 !text-sm !font-medium hover:!bg-brand-600 focus:!shadow-none;\n}\n.fc-toolbar-title {\n  @apply !text-lg !font-medium text-gray-800 dark:text-white/90;\n}\n.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child {\n  @apply rounded-lg bg-gray-100 p-0.5 dark:bg-gray-900;\n}\n.fc-header-toolbar.fc-toolbar .fc-toolbar-chunk:last-child .fc-button {\n  @apply !h-auto !w-auto rounded-md !border-0 bg-transparent !px-5 !py-2 text-sm font-medium text-gray-500 hover:text-gray-700 focus:!shadow-none dark:text-gray-400;\n}\n.fc-header-toolbar.fc-toolbar\n  .fc-toolbar-chunk:last-child\n  .fc-button.fc-button-active {\n  @apply text-gray-900 bg-white dark:bg-gray-800 dark:text-white;\n}\n.fc-theme-standard th {\n  @apply !border-x-0 border-t !border-gray-200 bg-gray-50 !text-left dark:!border-gray-800 dark:bg-gray-900;\n}\n.fc-theme-standard td,\n.fc-theme-standard .fc-scrollgrid {\n  @apply !border-gray-200 dark:!border-gray-800;\n}\n.fc .fc-col-header-cell-cushion {\n  @apply !px-5 !py-4 text-sm font-medium uppercase text-gray-400;\n}\n.fc .fc-daygrid-day.fc-day-today {\n  @apply bg-transparent;\n}\n.fc .fc-daygrid-day {\n  @apply p-2;\n}\n.fc .fc-daygrid-day.fc-day-today .fc-scrollgrid-sync-inner {\n  @apply rounded bg-gray-100 dark:bg-white/[0.03];\n}\n.fc .fc-daygrid-day-number {\n  @apply !p-3 text-sm font-medium text-gray-700 dark:text-gray-400;\n}\n.fc .fc-daygrid-day-top {\n  @apply !flex-row;\n}\n.fc .fc-day-other .fc-daygrid-day-top {\n  opacity: 1;\n}\n.fc .fc-day-other .fc-daygrid-day-top .fc-daygrid-day-number {\n  @apply text-gray-400 dark:text-white/30;\n}\n.event-fc-color {\n  @apply rounded-lg py-2.5 pl-4 pr-3;\n}\n.event-fc-color .fc-event-title {\n  @apply p-0 text-sm font-normal text-gray-700;\n}\n.fc-daygrid-event-dot {\n  @apply w-1 h-5 ml-0 mr-3 border-none rounded;\n}\n.fc-event {\n  @apply focus:shadow-none;\n}\n.fc-daygrid-event.fc-event-start {\n  @apply !ml-3;\n}\n.event-fc-color.fc-bg-success {\n  @apply border-success-50 bg-success-50;\n}\n.event-fc-color.fc-bg-danger {\n  @apply border-error-50 bg-error-50;\n}\n.event-fc-color.fc-bg-primary {\n  @apply border-brand-50 bg-brand-50;\n}\n.event-fc-color.fc-bg-warning {\n  @apply border-orange-50 bg-orange-50;\n}\n.event-fc-color.fc-bg-success .fc-daygrid-event-dot {\n  @apply bg-success-500;\n}\n.event-fc-color.fc-bg-danger .fc-daygrid-event-dot {\n  @apply bg-error-500;\n}\n.event-fc-color.fc-bg-primary .fc-daygrid-event-dot {\n  @apply bg-brand-500;\n}\n.event-fc-color.fc-bg-warning .fc-daygrid-event-dot {\n  @apply bg-orange-500;\n}\n.fc-direction-ltr .fc-timegrid-slot-label-frame {\n  @apply px-3 py-1.5 text-left text-sm font-medium text-gray-500 dark:text-gray-400;\n}\n.fc .fc-timegrid-axis-cushion {\n  @apply text-sm font-medium text-gray-500 dark:text-gray-400;\n}\n\n.input-date-icon::-webkit-inner-spin-button,\n.input-date-icon::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  -webkit-appearance: none;\n}\n\n.swiper-button-prev svg,\n.swiper-button-next svg {\n  @apply !h-auto !w-auto;\n}\n\n.carouselTwo .swiper-button-next:after,\n.carouselTwo .swiper-button-prev:after,\n.carouselFour .swiper-button-next:after,\n.carouselFour .swiper-button-prev:after {\n  @apply hidden;\n}\n.carouselTwo .swiper-button-next.swiper-button-disabled,\n.carouselTwo .swiper-button-prev.swiper-button-disabled,\n.carouselFour .swiper-button-next.swiper-button-disabled,\n.carouselFour .swiper-button-prev.swiper-button-disabled {\n  @apply bg-white/60 !opacity-100;\n}\n.carouselTwo .swiper-button-next,\n.carouselTwo .swiper-button-prev,\n.carouselFour .swiper-button-next,\n.carouselFour .swiper-button-prev {\n  @apply h-10 w-10 rounded-full border-[0.5px] border-white/10 bg-white/90 !text-gray-700 shadow-slider-navigation backdrop-blur-[10px];\n}\n\n.carouselTwo .swiper-button-prev,\n.carouselFour .swiper-button-prev {\n  @apply !left-3 sm:!left-4;\n}\n\n.carouselTwo .swiper-button-next,\n.carouselFour .swiper-button-next {\n  @apply !right-3 sm:!right-4;\n}\n\n.carouselThree .swiper-pagination,\n.carouselFour .swiper-pagination {\n  @apply !bottom-3 !left-1/2 inline-flex !w-auto -translate-x-1/2 items-center gap-1.5 rounded-[40px] border-[0.5px] border-white/10 bg-white/60 px-2 py-1.5 shadow-slider-navigation backdrop-blur-[10px] sm:!bottom-5;\n}\n\n.carouselThree .swiper-pagination-bullet,\n.carouselFour .swiper-pagination-bullet {\n  @apply !m-0 h-2.5 w-2.5 bg-white opacity-100 shadow-theme-xs duration-200 ease-in-out;\n}\n\n.carouselThree .swiper-pagination-bullet-active,\n.carouselFour .swiper-pagination-bullet-active {\n  @apply w-6.5 rounded-xl;\n}\n\n.form-check-input:checked ~ span {\n  @apply border-[6px] border-brand-500 bg-brand-500 dark:border-brand-500;\n}\n\n.taskCheckbox:checked ~ .box span {\n  @apply opacity-100 bg-brand-500;\n}\n.taskCheckbox:checked ~ p {\n  @apply text-gray-400 line-through;\n}\n.taskCheckbox:checked ~ .box {\n  @apply border-brand-500 bg-brand-500 dark:border-brand-500;\n}\n\n.task {\n  transition: all 0.2s ease; /* Smooth transition for visual effects */\n}\n\n.task {\n  border-radius: 0.75rem;\n  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1),\n    0px 1px 2px 0px rgba(16, 24, 40, 0.06);\n  opacity: 0.8;\n  cursor: grabbing; /* Changes the cursor to indicate dragging */\n}\n\n.custom-calendar .fc-h-event {\n  background-color: transparent;\n  border: none;\n  color: black;\n}\n.fc.fc-media-screen {\n  @apply min-h-screen;\n}\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.sub-pack-parent{\n  max-width: 80%;\n}\n\n.sub-pack{\n  box-shadow: 0px 0px 20px -7px #000000;\n}\n\n.sub-pack ul li.flex{\n  align-items: center;\n}\n\n.flexi-pack-amount{\n  font-size: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
